<template>
  <div class="addCoursework">
    <a-Modal
      title="发布作业"
      :visible="visible"
      @cancel="handleCancel"
      :width="900"
      :height="'900px'"
      :footer="null"
    >
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="作业标题：" prop="workName">
          <a-input v-model="form.workName" placeholder="请输入作业标题，不超过100字" />
        </a-form-model-item>
        <a-form-model-item label="作业类型：" prop="workType">
          <a-radio-group v-model="form.workType">
            <a-radio value="attachment" style="margin-right:30px;">
              附件题
            </a-radio>
            <a-radio value="test">
              考试测验
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="作业要求：" prop="workRequire">
          <editor
              @getEditorHtml="getEditorHtml"
              :editorHtml="formattDes"
              ref="editor"
          ></editor>
          <!-- <a-input v-model="form.workRequire" type="textarea" placeholder="请简单描述本次作业的要求，不超过200字" /> -->
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 6, offset: 18 }" style="border-top: 1px solid #ccc;margin-bottom: 0;padding-top: 10px;">
          <a-button @click="handleCancel" style="margin-right: 10px;">取消</a-button>
          <a-button @click="getEditorHtml1" type="primary">确定</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-Modal>
  </div>
</template>

<script>

import Editor from './../../../../components/Editor.vue';
export default {
  components: {
    Editor
  },
  data () {
    return {
      visible: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        workName: '',
        workRequire: '',
        workType: 'attachment'
      },
      rules: {
        workName: [
          { required: true, message: '请输入作业标题', trigger: 'blur' },
          { max: 100, message: '最多输入100个字符', trigger: 'blur' }
        ],
        workRequire: [
          { required: true, message: '请简单描述本次作业的要求', trigger: 'blur' },
          // { max: 200, message: '最多输入200个字符', trigger: 'blur' }
        ],
        workType: [
          { required: true, message: '请简单描述本次作业的要求', trigger: 'blur' }
        ]
      },
      editorRes : '',
      formattDes : '',
    };
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    getEditorHtml1(){
      this.$refs.editor.getEditor();
    },
    getEditorHtml(res){
      console.log(res);
      // if (!this.title){
      //     this.$message.error('标题不能为空');
      //     return;
      // }
      // if (!this.articleType){
      //     this.$message.error('类型不能为空');
      //     return;
      // }
      if (res == '<p><br></p>'){
          this.$message.error('内容不能为空');
          return
      }
      this.formattDes = res;
      this.form.workRequire = this.formattDes;
      this.onSubmit();
    },
    onSubmit() {
      
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let that = this;
          this.$confirm({
            title: '提示',
            content: '确定发布作业吗?',
            onOk() {
              that.sbmAddCoursework();
            },
            onCancel() {
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    sbmAddCoursework(){
      // console.log({
      //   'attDes': this.form.workRequire,
      //   'attTitle': this.form.workName,
      //   'createdBy': this.appUtils.getUserId(),
      //   'researchId': this.appUtils.getResearchId(),
      //   'attType': 'work',
      //   'workType': this.form.workType,
      // });
      let url = this.apis.coursework.addCoursework;
      this.http.post(url,{
        'attDes': this.formattDes,
        'attTitle': this.form.workName,
        'createdBy': this.appUtils.getUserId(),
        'researchId': this.appUtils.getResearchId(),
        'attType': 'work',
        'workType': this.form.workType,
      })
      .then((res)=>{
        if (res.status == 0){
          this.$message.success('新增作业成功');
          this.handleCancel();
          this.$emit('getAllAttInfo');
          
          let obj ={
            attinfoId: res.data.attinfoId
          };
          let objStr = JSON.stringify(obj);
          sessionStorage.setItem(this.constStatic.COURSE_INFO, [objStr]);
          if (res.data.workType == 'test'){
            this.$router.push({path: '/settingWrapTest'});
          } else {
            this.$confirm({
              title: '注意',
              content: '请至少设置一条作业题目，否则学员无法提交作业',
              onOk() {},
              onCancel() {},
            });
            this.$router.push({path: '/settingWrap/questionSetting'});
          }
        }
      }).catch((err)=> {
        this.$message.error(err.message);
      });
    },
    handleCancel() {
      this.visible = false;
    }
  }
}
</script>